"use strict";

exports.__esModule = true;
exports.default = void 0;

var _default = function _default(value) {
  return typeof value === 'string';
};

exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./~/redux-actions/lib/utils/isString.js
// module id = 641
// module chunks = 0